(function () {
  const STAGGER_MS = 90;
  const THRESHOLD = 0.15;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isEditor = !!(window.Shopify && window.Shopify.designMode);

  function hasStickyOrFixedDescendant(section) {
    const elements = section.querySelectorAll('*');
    for (let i = 0; i < elements.length; i++) {
      const position = getComputedStyle(elements[i]).position;
      if (position === 'sticky' || position === 'fixed') return true;
    }
    return false;
  }

  function markSections() {
    // Auto-tag every top-level content section so merchants don't need to edit
    // each section file by hand. Sections that already contain a manually
    // placed [data-animate] (e.g. individual grid items) are left alone so
    // their own finer-grained reveal isn't wrapped in a second one. Sections
    // with sticky/fixed descendants are skipped: a transform on the ancestor
    // would silently break that positioning even after the animation ends.
    document.querySelectorAll('#MainContent .shopify-section, footer .shopify-section').forEach((section) => {
      if (section.hasAttribute('data-animate')) return;
      if (section.querySelector('[data-animate]')) return;
      if (hasStickyOrFixedDescendant(section)) return;
      section.setAttribute('data-animate', '');
    });
  }

  function applyStagger(elements) {
    const groups = new Map();
    elements.forEach((el) => {
      const group = el.closest('.shopify-section') || document.body;
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push(el);
    });
    groups.forEach((groupElements) => {
      groupElements.forEach((el, index) => {
        el.style.transitionDelay = `${index * STAGGER_MS}ms`;
      });
    });
  }

  function init() {
    markSections();
    const elements = Array.from(document.querySelectorAll('[data-animate]'));
    if (elements.length === 0) return;

    if (reduceMotion || isEditor) {
      elements.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    applyStagger(elements);

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      { threshold: THRESHOLD }
    );

    elements.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
